import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';

const VERT_PADDING = 8;
const HEIGHT = 70 - VERT_PADDING * 2;
const ARROW_WIDTH = 30;

export const CalendarContainer = styled.div`
  width: 100%;
  padding: ${VERT_PADDING}px 30px;
  background-color: ${({ theme }) => theme.backgroundLighter};

  @media (${laptopMediumMax}) {
    padding: ${VERT_PADDING}px 15px;
  }
`;

export const CalendarWrapper = styled.div`
  height: ${HEIGHT}px;
  width: 100%;
  overflow: hidden;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 1260px;
  margin: 0 auto;
  position: relative;
`;

export const CalendarBox = styled.div`
  position: relative;
  width: 100%;
`;

export const CalendarSlider = styled.nav`
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  height: ${HEIGHT + 10}px;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  transition: transform 0.3s cubic-bezier(0, 0, 0.21, 0.99);
`;

export const CalendarList = styled.ul`
  position: absolute;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
  overflow: visible;
  white-space: nowrap;
  min-width: 100%;
  transition: all 0.4s ease-in-out;
`;

export const CalendarListItem = styled.li`
  display: inline-block;
  margin: -${VERT_PADDING}px 0 0 0;
`;

export const CalendarDate = styled.div<{ isActive: boolean }>`
  line-height: 1;
  height: ${HEIGHT}px;
  padding: 19px 17px;
  font-size: 15px;
  white-space: nowrap;
  display: block;
  text-decoration: none;
  position: relative;
  z-index: 3;
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
  font-weight: 600;
  background-color: transparent;
  transition: color 0.3s ease-in;
`;

export const CalendarSliderBar = styled.div<{ width?: number; transform?: string }>`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  bottom: 0;
  border-bottom: ${VERT_PADDING}px solid ${({ theme }) => theme.primary};
  transition: all 400ms ease 0s;

  ${({ width }) => `width: ${width || 0}px;`}
  ${({ transform }) => (transform ? `transform: ${transform};` : ``)}
`;

const Arrow = css`
  position: absolute;
  cursor: pointer;
  width: ${ARROW_WIDTH}px;
  top: 0;
  bottom: 0;
  z-index: 3;
  background: linear-gradient(
    90deg,
    rgba(239, 239, 239, 1) 0%,
    rgba(239, 239, 239, 0.56) 25%,
    rgba(239, 239, 239, 1) 75%,
    rgba(239, 239, 239, 1) 100%
  );
  transition: background 300ms ease;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowRight = styled.div`
  ${Arrow}
  right: 0;
`;

export const ArrowLeft = styled.div`
  ${Arrow}
  left: 0;
`;
